/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class TaskTypeIds {
    static readonly simpleTask: string = "b3702d91-b979-41ce-9a58-3a0e774c14bc";
}
